/* 
 * filter country options according to user input
 */
export function filterCountry(input, countryOptions) {
    if (input === "" || !input) {
      return countryOptions;
    }
    let filteredOptions = [];
    countryOptions.forEach(option => {
      // show options with matched abbreviations first
      if (option.countryNameTwoBytes.includes(input.trim().toUpperCase()))
        filteredOptions.unshift(option);
      else if (option.countryName.toLowerCase().includes(input.trim().toLowerCase()))
        filteredOptions.push(option);
    });
    return filteredOptions;
  }
